export class Settings {
    language: string;
}